module.exports = __webpack_public_path__ + "img/viewer-3d.68754740.svg";